import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@reserve/store/types'
import {IEDate, uGetDateFormat, uGetIsInDate} from '@appbase/util';
import { openReserveCalendarItem } from '@reserve/popup-handler';
import modalHelper from '@appbase/util/modal-helper';
import * as dateutil from '@appbase/util/date-helper';
import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';
import {getAmpm, getTimetext} from "@reserve/disp-helper";

@Component({
    computed: mapGetters({
        dailyEvents: types.CALENDAR_DAILY_EVENT_LIST,
        selectedResources: types.SELECTED_RESOURCE_LIST,
        currentDate: types.CALENDAR_DATE_CURRENT,
        rightPaneOpen: types.CALENDAR_RIGHTPANE_OPEN
    }),

    methods: mapActions({
        loadDailyEvents: types.CALENDAR_DAILY_EVENT_LOAD
    })
})
export default class ResourceEventList  extends Vue {
    loadDailyEvents!: () => Promise<any>;

    dailyEvents!: reserve.CalendarItem[];
    selectedResources!: reserve.ResourceItemBase[];
    currentDate!: reserve.DateItem;
    eventsModel: reserve.CalendarItem[] = [];
    rightPaneOpen!: boolean;

    @Watch('dailyEvents')
    onEventsChanged(newVal: reserve.CalendarItem[]) {
        this.eventsModel = newVal.filter(
            m => {
                let endDate = IEDate(m.end);
                endDate.setSeconds(-1); // set to 1 second before end time to include events that end exactly at start of day
                return m.id !== 'null' &&
                    (
                        (dateutil.uGetDateFormat("dd", IEDate(m.start)) === dateutil.uGetDateFormat("dd", IEDate(this.currentDate.date)))
                        || uGetIsInDate(IEDate(this.currentDate.date), IEDate(m.start), endDate)
                    )
            }
        );
    }

    @Watch('selectedResources')
    onSelectedResourceChanged(newVal: ewsResource.EwsResourceItem[]) {
        this.loadEvents();
    }

    @Watch('rightPaneOpen')
    onPaneOpen(newVal: boolean) {
        if(newVal) {
            this.loadEvents();
        }
    }

    created() {
        this.loadEvents();
    }

    loadEvents() {
        if(this.rightPaneOpen) {
            this.loadDailyEvents();
        }        
    }

    getTimetext(event: reserve.CalendarItem) {
        if(event.isAllDayEvent) {
            return this.$t('W_Schedule_Allday').toString();
        } else {
            return `${getAmpm(event.start)} ${getTimetext(event.start)}`;
        }        
    }

    getDuration(event: reserve.CalendarItem) {
        if(event.isAllDayEvent) {
            return "";
        } else {
            var start = IEDate(event.start);
            var end = IEDate(event.end);
            var duration = end.getTime() - start.getTime();

            return `${(duration / (1000 * 60 * 60)).toFixed(1)} ${this.$t('W_Hour').toString()}`;
        }        
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true;
        return colorClass;
    }

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else if (event.appointmentType === 'Exception') {
            openReserveCalendarItem(event, 'exception');
        } else {
            openReserveCalendarItem(event);
        }      
    }
}